var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "hourglass_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.615 0h40.769v40H.615z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hourglass_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.466 33.334h13.067v-5c0-1.855-.627-3.462-1.881-4.82-1.255-1.36-2.805-2.04-4.652-2.04s-3.398.68-4.652 2.04c-1.254 1.358-1.882 2.965-1.882 4.82v5zM21 18.526c1.847 0 3.397-.68 4.652-2.038 1.254-1.36 1.881-2.966 1.881-4.821v-5H14.466v5c0 1.855.628 3.462 1.882 4.82 1.254 1.36 2.805 2.039 4.652 2.039zm11.303 17.308H9.697c-.361 0-.664-.12-.908-.36a1.199 1.199 0 01-.366-.891c0-.354.122-.651.366-.89.244-.24.547-.36.908-.36h2.221v-5c0-1.811.475-3.476 1.423-4.995A8.4 8.4 0 0117.224 20a8.4 8.4 0 01-3.883-3.338 9.244 9.244 0 01-1.423-4.995v-5H9.697c-.361 0-.664-.12-.908-.36a1.199 1.199 0 01-.366-.89c0-.355.122-.652.366-.891.244-.24.547-.359.908-.359h22.606c.36 0 .663.12.908.36.244.24.366.536.366.89 0 .355-.122.652-.366.891-.245.24-.547.359-.908.359H30.08v5a9.245 9.245 0 01-1.422 4.995A8.401 8.401 0 0124.776 20a8.4 8.4 0 013.883 3.338 9.245 9.245 0 011.422 4.996v5h2.222c.36 0 .663.12.908.36.244.239.366.536.366.89s-.122.651-.366.89c-.245.24-.547.36-.908.36z",
    fill: "#2E6EDF"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/hourglass.351e6c80.svg";
export { SvgHourglass as ReactComponent };